var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, delay, fork, put, select } from 'redux-saga/effects';
import { HttpStatusCode } from "../../common";
import { IntelligentAssignmentSummary } from '../constants';
import { photoCaptureIntelligentDamageDetectionFailureAction, photoCaptureIntelligentDamageDetectionGetRequestAction, photoCaptureIntelligentDamageDetectionSuccessAction, photoCaptureIntelligentUpdateIterationDamageCallStatusAction } from '../actions';
import { IntelligentPhotoCaptureAttachmentIterationStatus } from '../enums';
import { attachmentBatchActivityInfo, getErrorMessagesBasedOnStatusCode } from '../utilities';
import { getIsPolling, getPhotoCaptureClaimNumber } from '../selectors';
import { PhotoCaptureIntelligentDamageDetectionService } from '../services';
import { intelligentPhotoCaptureFailureLoggingSaga } from './intelligentPhotoCaptureFailureLoggingSaga';
export function* photoCaptureIntelligentDamageDetectionSaga(action) {
    const requestIdParts = action.payload.request.requestId.split('_');
    const parsedIterationId = parseInt(requestIdParts[requestIdParts.length - 1], 10);
    const iterationId = Number.isFinite(parsedIterationId) ? parsedIterationId : undefined;
    const claimNumber = yield select(getPhotoCaptureClaimNumber);
    let damageDetectionRequest = Object.assign(Object.assign({}, action.payload.request), { claimNumber });
    try {
        const attachmentsWithS3Urls = yield call(() => __awaiter(this, void 0, void 0, function* () {
            return Promise.all(action.payload.request.attachments.map((attachment) => __awaiter(this, void 0, void 0, function* () {
                if (attachment.uri) {
                    return attachment;
                }
                if (!attachment.docUID) {
                    return attachment;
                }
                const s3Url = yield attachmentBatchActivityInfo.gets3UrlForDocUID(attachment.docUID);
                return Object.assign(Object.assign({}, attachment), { uri: s3Url });
            })));
        }));
        damageDetectionRequest = Object.assign(Object.assign({}, damageDetectionRequest), { attachments: attachmentsWithS3Urls });
        const damageDetectionService = new PhotoCaptureIntelligentDamageDetectionService();
        const response = yield call([damageDetectionService, damageDetectionService.detectDamage], action.payload.companyCode, damageDetectionRequest, action.payload.instanceReferenceId);
        yield put(photoCaptureIntelligentDamageDetectionSuccessAction(response, iterationId));
        const isPolling = yield select(getIsPolling);
        if (isPolling && response.status === String(HttpStatusCode.OK)) {
            yield delay(IntelligentAssignmentSummary.WAIT_TIME_TO_CALL_DAMAGE_DETECTION_MS);
            yield put(photoCaptureIntelligentDamageDetectionGetRequestAction(action.payload.companyCode, damageDetectionRequest.requestId, action.payload.instanceReferenceId, isPolling, iterationId));
        }
    }
    catch (error) {
        const errorMessage = getErrorMessagesBasedOnStatusCode(error);
        // Fire-and-forget error logging so catch-path handling is not blocked.
        yield fork(intelligentPhotoCaptureFailureLoggingSaga, {
            actionType: action.type,
            response: error,
            requestedPayload: damageDetectionRequest,
            claimNumber,
            companyCode: action.payload.companyCode,
            instanceReferenceId: action.payload.instanceReferenceId,
            errorDetail: errorMessage
        });
        if (typeof iterationId === 'number' && Number.isFinite(iterationId)) {
            yield put(photoCaptureIntelligentUpdateIterationDamageCallStatusAction(iterationId, IntelligentPhotoCaptureAttachmentIterationStatus.COMPLETED));
        }
        yield put(photoCaptureIntelligentDamageDetectionFailureAction(errorMessage, iterationId));
    }
}
//# sourceMappingURL=intelligentPhotoCaptureDamageDetectionSaga.js.map